'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Smoothies = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Smoothies, _Component);

  function Smoothies() {
    (0, _classCallCheck3.default)(this, Smoothies);
    return (0, _possibleConstructorReturn3.default)(this, (Smoothies.__proto__ || (0, _getPrototypeOf2.default)(Smoothies)).apply(this, arguments));
  }

  (0, _createClass3.default)(Smoothies, [{
    key: 'render',
    value: function render() {
      var styles = require('./Recipes.scss');
      var smoothieImg = require('./Assets/smoothie.png');
      var smoothieImg2 = require('./Assets/smoothie2.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.recipePanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Beautiful Banana and Berry Smoothies'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8 },
              _react2.default.createElement(
                'p',
                null,
                'Makes 2'
              ),
              _react2.default.createElement(
                'p',
                null,
                'This smoothie provides 1 serve of fruit and 1 serve of dairy in a delicious smoothie. Add a weetbix or 2/3 cup of oats to add a serve of grains - this would make for a good breakfast, especially in summer.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ingredients:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 banana'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/2 cup blueberries'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/2 cup raspberries'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '2 cups milk [or alternative, e.g. calcium-fortified soy milk]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '6 cubes of ice'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Instructions:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Add all ingredients to a blender and whizz until smooth.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Serve'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Note: You can use frozen fruit and less ice cubes, if desired.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(ReactBootstrap.Image, { src: smoothieImg2, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: smoothieImg, responsive: true })
            ),
            _react2.default.createElement(ReactBootstrap.Col, { md: 1 })
          )
        )
      );
    }
  }]);
  return Smoothies;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Smoothies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Smoothies.js
// module id = 1233
// module chunks = 0